import { Link, NavLink, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

const links = [
  { to: "/", label: "Home" },
  { to: "/books", label: "Books" },
  { to: "/journal", label: "Journal" },
  { to: "/healing", label: "Healing" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const onHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  const darkText = !onHome || scrolled;

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !onHome
          ? "backdrop-blur-xl bg-white/80 border-b border-[#C5A059]/20"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-5 flex items-center justify-between">
        <Link
          to="/"
          data-testid="nav-logo"
          className={`font-serif text-2xl md:text-3xl tracking-tight whitespace-nowrap ${darkText ? "text-[#1A1F24]" : "text-white"}`}
        >
          Gemma <span className="italic font-light text-[#C5A059]">Veda</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8 whitespace-nowrap">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm tracking-[0.18em] uppercase transition-colors ${
                  isActive
                    ? "text-[#C5A059]"
                    : darkText
                    ? "text-[#1A1F24] hover:text-[#C5A059]"
                    : "text-white/90 hover:text-[#E8D8B7]"
                }`
              }
              end={l.to === "/"}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <button
          type="button"
          aria-label="Toggle menu"
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          className={`md:hidden text-sm tracking-[0.2em] uppercase ${darkText ? "text-[#1A1F24]" : "text-white"}`}
        >
          {open ? "Close" : "Menu"}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-white border-t border-[#C5A059]/20">
          <nav className="flex flex-col px-6 py-6 gap-4">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                className="text-base font-serif text-[#1A1F24] hover:text-[#C5A059]"
                end={l.to === "/"}
              >
                {l.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
